"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getHistory_1 = require("./getHistory");
function handleRequiredAuthentication() {
    var history = getHistory_1.default();
    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    history.replace({ pathname: '/sessions/new', query: { return_to: returnTo } });
}
exports.default = handleRequiredAuthentication;
//# sourceMappingURL=handleRequiredAuthentication.js.map